import { useState } from 'react';
import { InputAdornment } from '@material-ui/core';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { IconAiPen } from 'src/assets/icons/IconAiPen';
import { IconArrow } from 'src/assets/icons/IconArrow';
import { CustomIconButton } from 'src/components/CustomIconButton';
import { CustomInput } from 'src/components/CustomInput';

import { useStyles } from './useStyles';

export const InstructionsInput = ({ className, onSubmit, disabled }) => {
  const styles = useStyles();

  const [manualValue, setManualValue] = useState('');

  const handleInputChange = (event) => {
    setManualValue(event.target.value);
  };

  const handleInputKeyDown = (event) => {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      onSubmit(manualValue);
      setManualValue('');
    }
  };

  const handleClick = () => {
    onSubmit(manualValue);
    setManualValue('');
  };

  return (
    <CustomInput
      className={cx(styles.root, className)}
      classes={{
        adornedStart: styles.inputStartAdornment,
        adornedEnd: styles.inputEndAdornment,
      }}
      placeholder="Write your own instructions"
      value={manualValue}
      onChange={handleInputChange}
      onKeyDown={handleInputKeyDown}
      startAdornment={
        <InputAdornment position="start">
          <IconAiPen className={styles.iconAiPen} />
        </InputAdornment>
      }
      endAdornment={
        <InputAdornment position="end">
          <CustomIconButton onClick={handleClick}>
            <IconArrow className={styles.iconSend} />
          </CustomIconButton>
        </InputAdornment>
      }
      disabled={disabled}
      multiline
      fullWidth
    />
  );
};

InstructionsInput.propTypes = {
  className: PropTypes.string,
  onSubmit: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};
InstructionsInput.defaultProps = {
  className: '',
  disabled: false,
};
